<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('project_payment')">
      <project-payment-action-button @open-modal="openModal" />
    </app-page-top-section>

    <!-- Search & Filter -->
    <div class="mb-3 d-flex gap-2" style="flex-wrap: nowrap;">
      <select v-model="filterProject" @change="fetchPayments" class="form-select" style="min-width: 200px;">
        <option value="">All Projects</option>
        <option v-for="project in projects" :key="project.id" :value="project.id">
          {{ project.title }}
        </option>
      </select>

      <input
        type="date"
        v-model="filterStartDate"
        @change="fetchPayments"
        placeholder="Start Date"
        class="form-control"
        style="min-width: 150px;"
      />

      <input
        type="date"
        v-model="filterEndDate"
        @change="fetchPayments"
        placeholder="End Date"
        class="form-control"
        style="min-width: 150px;"
      />
    </div>

    <!-- Payments Table -->
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>{{ $t('id') }}</th>
          <th>{{ $t('date') }}</th>
          <th>{{ $t('project') }}</th>
          <th>{{ $t('client') }}</th>
          <th>{{ $t('payment_amount') }}</th>
          <th>{{ $t('actions') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(payment,index) in payments.data" :key="payment.id">
          <td>{{ (payments.current_page - 1) * 10 + index + 1 }}</td>
          <td>{{ formatDate(payment.date) }}</td>
          <td>{{ payment.project ? payment.project.title : '-' }}</td>
          <td>{{ payment.client ? payment.client.name : '-' }}</td>
          <td>{{ payment.payment_amount }}</td>
          <td>
            <a v-if="payment.income_id" :href="`/incomes/${payment.income_id}/invoice`" target="_blank" class="btn btn-sm btn-info text-white me-1">Invoice</a>
            <button class="btn btn-sm btn-primary me-1" @click="editPayment(payment)">Edit</button>
            <button class="btn btn-sm btn-danger" @click="deletePayment(payment.id)">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Custom Pagination -->
    <nav v-if="payments.last_page > 1">
      <ul class="pagination justify-content-center">
        <li
          class="page-item"
          :class="{ disabled: payments.current_page === 1 }"
          @click="changePage(payments.current_page - 1)"
        >
          <a class="page-link" href="#">Previous</a>
        </li>

        <li
          class="page-item"
          v-for="page in totalPages"
          :key="page"
          :class="{ active: payments.current_page === page }"
          @click="changePage(page)"
        >
          <a class="page-link" href="#">{{ page }}</a>
        </li>

        <li
          class="page-item"
          :class="{ disabled: payments.current_page === payments.last_page }"
          @click="changePage(payments.current_page + 1)"
        >
          <a class="page-link" href="#">Next</a>
        </li>
      </ul>
    </nav>

    <!-- Modal -->
    <project-payment-form-modal
      v-if="isModalActive"
      v-model="isModalActive"
      :payment="selectedPayment"
      @saved="fetchPayments"
    />
  </div>
</template>

<script>
import ProjectPaymentActionButton from './Components/ProjectPaymentActionButton.vue'
import ProjectPaymentFormModal from './Components/ProjectPaymentFormModal.vue'

export default {
  name: 'AppProjectPayments',
  components: { ProjectPaymentActionButton, ProjectPaymentFormModal },
  data() {
    return {
      payments: { data: [], current_page: 1, last_page: 1 },
      projects: [],
      isModalActive: false,
      selectedPayment: null,
      filterProject: '',
      filterStartDate: '',
      filterEndDate: ''
    }
  },
  mounted() {
    this.fetchProjects()
    this.fetchPayments()
  },
  computed: {
    totalPages() {
      let pages = []
      for (let i = 1; i <= this.payments.last_page; i++) {
        pages.push(i)
      }
      return pages
    }
  },
  methods: {
    fetchProjects() {
      axios.get('/project-payments/projects')
        .then(res => { this.projects = res.data })
        .catch(err => console.error(err))
    },
    fetchPayments(page = 1) {
      axios.get('/project-payments', {
        params: {
          project_id: this.filterProject,
          start_date: this.filterStartDate,
          end_date: this.filterEndDate,
          per_page: 10,
          page: page
        }
      }).then(res => { this.payments = res.data })
    },
    changePage(page) {
      if (page < 1 || page > this.payments.last_page) return
      this.fetchPayments(page)
    },
    openModal() {
      this.selectedPayment = null
      this.isModalActive = true
    },
    editPayment(payment) {
      this.selectedPayment = payment
      this.isModalActive = true
    },
    deletePayment(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'This will also delete the associated income entry.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          axios.delete(`/project-payments/${id}`).then(() => {
            this.fetchPayments(this.payments.current_page)
            Swal.fire({
              title: 'Deleted!',
              text: 'Your payment record has been deleted.',
              icon: 'success',
              confirmButtonColor: '#3085d6'
            })
          })
        }
      })
    },
    formatDate(date) {
      if (!date) return '-'
      const d = new Date(date)
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getFullYear()
      return `${day}-${month}-${year}`
    }
  }
}
</script>

<style>
.pagination .page-item.disabled .page-link {
  pointer-events: none;
  opacity: 0.5;
}
.pagination .page-item.active .page-link {
  background-color: #0d6efd;
  border-color: #0d6efd;
  color: #fff;
}
</style>

